﻿export class PostTiles {
    public static addHasTagToTags($: JQueryStatic): void {
        $(".attrax-post-tile__tag").each(function (idx, val) {
            const tagText = $(val).find("a").text();
            const addHash = "#" + tagText;
            $(val).find("a").text(addHash);
        });
    }
}
